import React, { useState } from "react";
import PropTypes from "prop-types";

const RenderExplainLink = ({ setExplainVisible, label }) => {
  const [showText, setShowText] = useState(false);
  const onClick = () => {
    setShowText(!showText);
    setExplainVisible(!showText);
  };

  return (
    <a className="varsome-right" onClick={onClick}>
      {label}
    </a>
  );
};

RenderExplainLink.propTypes = {
  label: PropTypes.string,
  setExplainVisible: PropTypes.func,
};

RenderExplainLink.defaultProps = {
  label: "",
  setExplainVisible: () => {},
};
export default RenderExplainLink;
